import emailjs from '@emailjs/browser';
import { useId, useState } from 'react';
import '../styles/contact.css';

const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

function ContactForm() {
  const formId = useId();
  const nameId = `${formId}-name`;
  const emailId = `${formId}-email`;
  const phoneId = `${formId}-phone`;
  const messageId = `${formId}-message`;

  const [fromName, setFromName] = useState('');
  const [fromEmail, setFromEmail] = useState('');
  const [fromPhone, setFromPhone] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle');
  const [feedback, setFeedback] = useState('');

  const isConfigured = Boolean(serviceId && templateId && publicKey);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isConfigured) {
      setFeedback('E-postkonfiguration saknas. Kontrollera att .env är korrekt ifylld.');
      setStatus('error');
      return;
    }

    setStatus('sending');
    setFeedback('');

    const time = new Date().toLocaleString('sv-SE', {
      dateStyle: 'full',
      timeStyle: 'short',
    });

    const templateParams = {
      from_name: fromName.trim(),
      from_email: fromEmail.trim(),
      from_phone: fromPhone.trim() || ',',
      message: message.trim(),
      time,
    };

    try {
      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      setStatus('success');
      setFeedback('Tack! Meddelandet har skickats.');
      setFromName('');
      setFromEmail('');
      setFromPhone('');
      setMessage('');
    } catch {
      setStatus('error');
      setFeedback('Det gick inte att skicka just nu. Försök igen eller kontakta mig via LinkedIn eller telefon.');
    }
  };

  return (
    <>
      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <div className="contact-fields">
          <label className="contact-label" htmlFor={nameId}>
            Namn <span className="contact-required">*</span>
          </label>
          <input
            id={nameId}
            name="from_name"
            className="contact-input"
            type="text"
            autoComplete="name"
            required
            value={fromName}
            onChange={(e) => setFromName(e.target.value)}
          />

          <label className="contact-label" htmlFor={emailId}>
            E-post <span className="contact-required">*</span>
          </label>
          <input
            id={emailId}
            name="from_email"
            className="contact-input"
            type="email"
            autoComplete="email"
            required
            value={fromEmail}
            onChange={(e) => setFromEmail(e.target.value)}
          />

          <label className="contact-label" htmlFor={phoneId}>
            Telefon
          </label>
          <input
            id={phoneId}
            name="from_phone"
            className="contact-input"
            type="tel"
            autoComplete="tel"
            value={fromPhone}
            onChange={(e) => setFromPhone(e.target.value)}
          />

          <label className="contact-label" htmlFor={messageId}>
            Meddelande <span className="contact-required">*</span>
          </label>
          <textarea
            id={messageId}
            name="message"
            className="contact-textarea"
            rows={5}
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <div className="contact-actions">
          <button
            className="contact-submit"
            type="submit"
            disabled={status === 'sending' || !isConfigured}
          >
            {status === 'sending' ? 'Skickar…' : 'Skicka'}
          </button>
        </div>

        {!isConfigured ? (
          <p className="contact-hint contact-hint--warn" role="status">
            Sätt REACT_APP_EMAILJS_* i <code>.env</code> och starta om utvecklingsservern.
          </p>
        ) : null}

        {feedback ? (
          <p
            className={`contact-feedback ${status === 'success' ? 'contact-feedback--ok' : 'contact-feedback--err'}`}
            role="status"
            aria-live="polite"
          >
            {feedback}
          </p>
        ) : null}
      </form>

      <p className="contact-alt">
        Föredrar du LinkedIn?{' '}
        <a href="https://www.linkedin.com/in/aryaeisa" target="_blank" rel="noopener noreferrer">
          Låt oss nätverka där :)
        </a>
        
      </p>
    </>
  );
}

export default ContactForm;
